import { SeriesCard as BaseSeriesCard } from './series-card'
import { SeriesCardBadgeInProgress } from './series-card-badge-in-progress'
import { SeriesCardContent } from './series-card-content'
import { SeriesCardImage } from './series-card-image'
import { SeriesCardIntensityBadge } from './series-card-intensity-badge'
import { SeriesCardMetaActive } from './series-card-meta-active'
import { SeriesCardDismissSeriesButton } from './series-card-dismiss-series-button'
import { SeriesCardProgress } from './series-card-progress'
import { SeriesCardTitle } from './series-card-title'
import React from 'react'
import { Programme } from 'src/dao/core-dao'
import { useProgrammeWorkoutProgress } from 'src/hook/use-programme-workout-progress'
import { cn } from 'src/lib/utils'
import { buildProgrammeOverviewUrl } from 'src/util/build-programme-overview-url'

export interface SeriesCardKeepGoingProps {
  series: Programme
  className?: string
  onCancelSeriesClick: () => void
}

export const SeriesCardKeepGoing = ({ series, className, onCancelSeriesClick }: SeriesCardKeepGoingProps): React.ReactElement => {
  const {
    completedClassesCount,
    totalClassesCount,
    isProgressReady,
    nextIncompleteClassTitle,
    nextIncompleteWorkoutId,
    nextIncompleteWeek,
  } = useProgrammeWorkoutProgress(series.id)

  const showTwoLineTitle = isProgressReady && nextIncompleteClassTitle

  return (
    <BaseSeriesCard
      series={series}
      className={cn('rounded-xl border border-success aspect-[9/10]', className)}
      to={buildProgrammeOverviewUrl(series.id, {
        isProgressReady,
        nextIncompleteWeek,
        nextIncompleteWorkoutId,
      })}
    >
      <SeriesCardImage>
        <SeriesCardContent className="gap-0">
          <div className="flex shrink-0 items-start justify-between gap-2">
            <SeriesCardBadgeInProgress />
            <div className="flex min-w-0 flex-1 items-center justify-end gap-2">
              {series.intensityId ? <SeriesCardIntensityBadge className="min-w-0 shrink justify-end" /> : null}
              <SeriesCardDismissSeriesButton
                data-testid="series-card-dismiss-series"
                onDismissClick={() => onCancelSeriesClick()}
              />
            </div>
          </div>
          <div className="flex min-h-0 flex-1 flex-col justify-end">
            {showTwoLineTitle ? (
              <div className="min-w-0">
                <p className="mb-1 line-clamp-1 font-roboto-condensed-medium text-lg capitalize lg:text-xl tracking-wide text-ivory">
                  {series.title.toLocaleLowerCase()}
                </p>
                <h3 className="line-clamp-2 text-left font-evogria text-2xl uppercase text-white lg:text-4xl">
                  {nextIncompleteClassTitle}
                </h3>
              </div>
            ) : (
              <SeriesCardTitle />
            )}
            <SeriesCardMetaActive />
          </div>
          <SeriesCardProgress completedCount={completedClassesCount} totalCount={totalClassesCount} isReady={isProgressReady} />
        </SeriesCardContent>
      </SeriesCardImage>
    </BaseSeriesCard>
  )
}
